import { RootState } from '../store';

const select = (state: RootState) => state.headcountChanges;

export const getIsLoading = (state: RootState) => select(state).isLoading;

export const getHeadcountChanges = (state: RootState) =>
  select(state).headcountChanges;

export const getActiveId = (state: RootState) => select(state).activeId;
